var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.error)?_c('div',{staticClass:"ayuda-error"},[_vm._v("Error en el script de esta ayuda: "+_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),_c('div',{ref:"cont",staticClass:"ayuda-render"})])
}
var staticRenderFns = []

export { render, staticRenderFns }